import { SITE } from "@/data/site";

export const buildWhatsAppLink = (message = "") => {
  const base = `https://wa.me/${SITE.whatsapp_e164}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
};

export const buildMailtoLink = ({ subject = "", body = "" } = {}) => {
  const qs = [];
  if (subject) qs.push(`subject=${encodeURIComponent(subject)}`);
  if (body) qs.push(`body=${encodeURIComponent(body)}`);
  return `mailto:${SITE.email}${qs.length ? "?" + qs.join("&") : ""}`;
};
